module.exports = __webpack_public_path__ + "img/6206132f71f4c6cbe54644240a851a10.png";